<template>
    <div
        :id="options.id"
        class="btn-container"
        :style="{float:options.align,margin:options.margin}"
    >
        <div
            v-show="hidden === false"
            class="button"
            :title="options.title"
            :class="options.class"
            @click="clickHandle"
            :style="{padding:options.padding}"
        >
            <span class="icon" v-if="options.icon" :class="['icon-'+options.icon,options.color]">
                <slot></slot>
            </span>
            <span class="button-text">{{getI18N(options.text)}}</span>
            <div class="corner-marker" v-if="options.markerNum && options.markerNum>0">{{options.markerNum}}</div>
        </div>
    </div>
</template>

<script>
import Gikam from "../../core/gikam-core";

export default {
    props: {
        options: Object
    },
    mounted() {
        Gikam.setInstance(this.$el, this);
        this.options.onRendered && this.options.onRendered.call(this);
    },
    data() {
        return {
            hidden: Gikam.isEmpty(this.options.hidden)
                ? false
                : this.options.hidden
        };
    },
    methods: {
        getI18N(text) {
            return Gikam.propI18N(text);
        },

        show() {
            this.hidden = false;
        },

        hide() {
            this.hidden = true;
        },

        clickHandle(event) {
            if (this.options.onClick) {
                this.options.onClick(event);
            }
            this.$emit("click", event);
        }
    }
};
</script>

<style>
.btn-container {
    display: inline-block;
    vertical-align: middle;
}

.btn-container .corner-marker {
    font-size: 12px;
    color: #fff;
    letter-spacing: 0;
    padding: 0 4px;
    margin-left: 5px;
    height: 14px;
    line-height: 14px;
    background: #ff003c;
    border-radius: 7px;
}

.button {
    display: flex;
    border: 1px solid #d9d9d9;
    /* height: 28px; */
    color: rgba(0, 0, 0, 0.65);
    font-family: "Microsoft YaHei", serif;
    font-size: 12px;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 4px;
    align-items: center;
    height: 24px;
}

.button.blue {
    background-color: #007aff;
    color: #fff;
}

.button.blue:hover {
    color: #fff;
    background-color: #007aff;
}

.button:hover {
    background-color: #f4f4f4;
}

.button:active {
    border-color: #007aff;
    color: #007aff;
    background-color: #fff;
}

.button .icon {
    margin-right: 2px;
    font-size: 16px;
}

.button .button-text {
    white-space: nowrap;
}

.button .icon.danger::before {
    color: #ff362e;
}

.button .icon.success::before {
    color: #29cf68;
}

.button .icon.primary::before {
    color: #007aff;
}

.button .icon.info::before {
    color: #1597a5;
}

.button .icon.warning::before {
    color: #f9762b;
}

.button .icon.wait::before {
    color: #f08239;
}
</style>